import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  RadioGroup,
  RadioGroupChangeEvent,
} from "@progress/kendo-react-inputs";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import Format from "../Common/Util_methods/formatParamOptions";
import { Button } from "@progress/kendo-react-buttons";
import { filterBy } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";

import {
  ComboBox,
  ComboBoxChangeEvent,
  ComboBoxFilterChangeEvent,
  MultiSelect,
  MultiSelectChangeEvent,
} from "@progress/kendo-react-dropdowns";
import {
  Label,
  Error,
  Hint,
  FloatingLabel,
} from "@progress/kendo-react-labels";
import {
  Form,
  Field,
  FormElement,
  FieldRenderProps,
  FormRenderProps,
  FieldWrapper,
} from "@progress/kendo-react-form";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Spinner from "../Common/Components/spinner";
import { SupportCasesApi } from "./api";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { initializeConnect } from "react-redux/es/components/connect";

type handler = () => void;
interface addSupportCaseProps {
  initialValues: any;
  jiraData: any;
  jiraUsers: any;
  user: string;
  type: any;
}

const AddSupportCaseForm = (props: addSupportCaseProps) => {
  const [selected, setSelected] = useState(0);
  const [jiraUsers, updateJiraUsers] = useState([]);
  const formRef = React.useRef(null);
  const [saveIssueLoading, updateSaveIssueLoading] = useState(false);
  const [saveSuccess, updateSaveSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [jiraLink, updateJiraLink] = useState(null);
    const [jiraError, setJiraError] = useState(null);
    const [copySuccess, updateCopySuccess] = useState(false);

  const handleSelect = (e: any) => {
    setSelected(e.selected);
  };
    useEffect(() => { updateCopySuccess(false); },[])
  useEffect(() => {
    updateJiraUsers(props.jiraUsers);
  }, [props.jiraUsers]);
    //useEffect(() => {
    //    console.log(props)
    //},[props])
  const [placeChildren, updatePlaceChildren] = useState(null);
  const [placeChild, updatePlaceChild] = useState(null);

    const copyIdHandler = (id) => {
        if (!id) return;

        (navigator as any).clipboard.writeText(id)
            .then(() => {
                updateCopySuccess(true);
            })
            .catch((err) => {
                console.error('Failed to copy text: ', err);
            });
    };

  const placeHandler = (e: any, values: any) => {
    //console.log(e);
    if (values != undefined) {
      for (var i = 0; i < values.length; i++) {
        if (values[i].value == e.target.value.value) {
          updatePlaceChildren(values[i].children);
        }
      }
    }
  };

  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);

  const emailValidator = (value: string) => {
    if (value == "" || value == undefined) return "";
   // console.log(value);
    return emailRegex.test(value) || value == ""
      ? ""
      : "Please enter a valid email.";
  };

  const stringValidator = (value: string) =>
    value != "" ? "" : "Please enter required information.";

  const LabelEmailInput = (fieldRenderProps: FieldRenderProps) => {
    const {
      validationMessage,
      visited,
      label,
      id,
      valid,
      disabled,
      ...others
    } = fieldRenderProps;
    const showValidationMessage: string | false | null =
      visited && validationMessage;
    return (
      <FieldWrapper>
        <Label
          className="k-form-label"
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
        >
          {label}
        </Label>
        <div className="k-form-field-wrap">
          <Input
            valid={valid}
            type={"email"}
            id={id}
            disabled={disabled}
            {...others}
          />
          {!showValidationMessage && <Hint>Enter email address.</Hint>}
          {showValidationMessage && <Error>{validationMessage}</Error>}
        </div>
      </FieldWrapper>
    );
  };
    const BasicTextArea = (fieldRenderProps: FieldRenderProps) => {
        const {
            validationMessage,
            visited,
            label,
            id,
            valid,
            disabled,
            ...others
        } = fieldRenderProps;
        const showValidationMessage: string | false | null =
            visited && validationMessage;

        return (
            <FieldWrapper>
                <Label
                    className="k-form-label"
                    style={{ color: "#000" }}
                    editorId={id}
                    editorValid={valid}
                    editorDisabled={disabled}
                >
                    {label}
                </Label>
                <div className="k-form-field-wrap" style={{ width: "100%", height: "150px" }}>
                    <TextArea valid={valid} id={id} disabled={disabled} {...others} style={{ width: "100%",height:"150px" }} />

                    {showValidationMessage && <Error>{validationMessage}</Error>}
                </div>
            </FieldWrapper>
        );
    };
  const BasicStringInput = (fieldRenderProps: FieldRenderProps) => {
    const {
      validationMessage,
      visited,
      label,
      id,
      valid,
      disabled,
      ...others
    } = fieldRenderProps;
    const showValidationMessage: string | false | null =
      visited && validationMessage;

    return (
      <FieldWrapper>
        <Label
          className="k-form-label"
          style={{ color: "#000" }}
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
        >
          {label}
        </Label>
        <div className="k-form-field-wrap">
                <Input valid={valid} id={id} disabled={disabled} {...others} style={{width:"100%"} } />

          {showValidationMessage && <Error>{validationMessage}</Error>}
        </div>
      </FieldWrapper>
    );
  };
  const comboBoxFilters = () => {
    return {
      users: (event: ComboBoxFilterChangeEvent) => {
      //  console.log(event);
        updateJiraUsers(props.jiraUsers.slice());
        //let newData: any = [];
        //newData = props.jiraUsers.filter(p => String(p.displayName).startsWith(event.filter.value));
        //console.log(props.jiraUsers, newData);
        //   updateJiraUsers(newData);
        //if (event.filter.value == "") {
        //    updateJiraUsers(props.jiraUsers);
        //}
        //else {

        //    updateJiraUsers(
        //        //filterBy(props.jiraUsers, {
        //        //    logic: 'and',
        //        //    filters: [
        //        //        { field: "displayName", operator: "startswith", value: event.filter.value, ignoreCase: true }
        //        //    ]
        //        // })
        //        //  filterBy(filterBy(Format.Countries(deviceObjects), event.filter));

        //        filterBy(props.jiraUsers, event.filter)
        //    );
        //}
      },
    };
  };

  const UserComboBox = (fieldRenderProps: FieldRenderProps) => {
    const {
      validationMessage,
      visited,
      label,
      id,
      valid,
      disabled,
      name,
      ...others
    } = fieldRenderProps;
    return (
      <FieldWrapper>
        <Label
          className="k-form-label"
          style={{ color: "#000" }}
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
        >
          {name.charAt(0).toUpperCase() + name.slice(1)}
        </Label>
        <div className="k-form-field-wrap">
          <ComboBox
            popupSettings={{ width: "auto" }}
            data={props.jiraUsers}
            textField={"displayName"}
            suggest={true}
            filterable={true}
            dataItemKey="displayName"
            // onFilterChange={comboBoxFilters().users}
            {...others}
          />
        </div>
      </FieldWrapper>
    );
  };
  const CountryDropDown = (fieldRenderProps: FieldRenderProps) => {
    const {
      validationMessage,
      visited,
      label,
      id,
      valid,
      disabled,
      ...others
    } = fieldRenderProps;
    const showValidationMessage: string | false | null =
      visited && validationMessage;

    return (
      <FieldWrapper>
        <Label
          className="k-form-label"
          style={{ color: "#000" }}
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
        >
          {label}
        </Label>
        <div className="k-form-field-wrap">
          <DropDownList
            data={props.jiraData.customfield_11926.allowedValues}
            textField="value"
            dataItemKey="value"
            {...others}
          />
          {showValidationMessage && <Error>{validationMessage}</Error>}
        </div>
      </FieldWrapper>
    );
  };

  const PlaceChildDropDown = (fieldRenderProps: FieldRenderProps) => {
    const {
      validationMessage,
      visited,
      label,
      id,
      valid,
      disabled,
      name,
      defaultValue,
      onChange,
      ...others
    } = fieldRenderProps;
    const showValidationMessage: string | false | null =
      visited && validationMessage;
    let textValue = "value";
    const onValueChange = React.useCallback(
      (e) => {
        // onChange callback expects argument with 'value' property

        onChange({ value: e.target.value });
        updatePlaceChild(e.target.value);
        //  placeHandler(e, name);
      },
      [onChange]
    );
    return (
      <FieldWrapper>
        <Label
          className="k-form-label"
          style={{ color: "#000" }}
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
        >
          {label}
        </Label>
        <div className="k-form-field-wrap">
          <DropDownList
            data={placeChildren}
            textField={textValue}
            dataItemKey={textValue}
            onChange={onValueChange}
            {...others}
          />
          {showValidationMessage && <Error>{validationMessage}</Error>}
        </div>
      </FieldWrapper>
    );
  };

  const BasicDropDown = (fieldRenderProps: FieldRenderProps) => {
    const {
      validationMessage,
      visited,
      label,
      id,
      valid,
      disabled,
      name,
      defaultValue,
      onChange,
      ...others
    } = fieldRenderProps;
    const showValidationMessage: string | false | null =
      visited && validationMessage;
    let defaultItem = null;
    let textValue = "value";
    if (name == "priority") textValue = "name";
    const onValueChange = React.useCallback(
      (e) => {
        // onChange callback expects argument with 'value' property

        onChange({ value: e.target.value });
        if (name == "customfield_10083") {
          placeHandler(e, props.jiraData[name].allowedValues);
        }
        //  placeHandler(e, name);
      },
      [onChange]
    );
    return (
      <FieldWrapper>
        <Label
          className="k-form-label"
          style={{ color: "#000" }}
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
        >
          {label}
        </Label>
        <div className="k-form-field-wrap">
          <DropDownList
            data={props.jiraData[name].allowedValues}
            textField={textValue}
            defaultItem={defaultItem}
            dataItemKey={textValue}
            //onChange={(e) => { placeHandler(e, name),onChange(e) }}
            onChange={onValueChange}
            {...others}
          />
          {showValidationMessage && <Error>{validationMessage}</Error>}
        </div>
      </FieldWrapper>
    );
  };

  const handleSubmit = (dataItem: { [name: string]: any }) => {
      setJiraError(null);

      // Remove `placeChild` from the form data
      const { placeChild, ...cleanedData2 } = dataItem;

      const { reporter, ...cleanedData } = cleanedData2;

      if (placeChild != null && cleanedData.customfield_10083 != undefined) {
          cleanedData.customfield_10083.child = placeChild; // Assign placeChild to the correct field
      }
     // console.log(cleanedData, cleanedData.customfield_16524)
      if (!cleanedData.customfield_16524) {
          alert("Please enter a Machine Serial.");
          return;
      }
      if (!cleanedData.summary) {
          alert("Please enter a Summary.");
          return;
      }
      if (!cleanedData.customfield_11926) {
          alert("Please enter a country in the customer tab.");
          return;
      }
      else if (!cleanedData.customfield_11926.value) {
          alert("Please enter a country in the customer tab.");
          return;
      }

      if (!cleanedData.description) {
          alert("Please enter a description.");
          return;
      }
      cleanedData.project = { key: "GSPUP" };
      cleanedData.issuetype = { id: 13851 };
      cleanedData.customfield_19410 = "149";
     // cleanedData.reporter = { name: reporter.name };

      // Convert cleaned data to JSON and submit it
      saveIssue({ fields: cleanedData });
  };
  const saveIssue = (_issue: any) => {
    const params: any = { issue: _issue };
    updateSaveIssueLoading(true);
    SupportCasesApi.saveIssue(params)
      .then((result: any) => {
        if (result.id) {
          updateSaveSuccess(true);
          updateJiraLink(
            "https://primapower-jira.atlassian.net/browse/" + result.key
          );
        } else if (result.errors != undefined) {
          if (result.errors.assignee != undefined) {
            setJiraError(result.errors.assignee);
          }
        }
       // console.log(result);

        updateSaveIssueLoading(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateSaveIssueLoading(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const renderCustomerInfoTab = () => {
    if (props.initialValues.customfield_11820 == undefined) {
      return <div>Loading customer info...</div>;
    }
    return (
      <TabStripTab title="Customer Information">
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_11820"}
              component={BasicStringInput}
              label={"Customer ID"}
              disabled={true}
            />
          </div>
        </FieldWrapper>
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_10823"}
              component={BasicStringInput}
              label={"Customer Name"}
              disabled={true}
            />
          </div>
        </FieldWrapper>
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_11926"}
              label={"Country"}
              component={CountryDropDown}
            />
          </div>
        </FieldWrapper>
      </TabStripTab>
    );
  };
  const renderBasicInfoTab = () => {
    if (props.jiraData == null) {
      return <div>Loading Jira data...</div>;
    }
    return (
        <TabStripTab title="Basic Information" contentClassName="k-tabstrip-width"
 >

        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"summary"}
              component={BasicStringInput}
              label={"Summary*"}
              required={true}
            />
          </div>
        </FieldWrapper>
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"description"}
              component={BasicTextArea} 
              label={"Description*"}
              required={true}
            />
          </div>
        </FieldWrapper>
        {props.jiraData.customfield_10083 != null && (
          <FieldWrapper>
            <div className="k-form-field-wrap">
              <Field
                name={"customfield_10083"}
                component={BasicDropDown}
                label={props.jiraData.customfield_10083.name}
              />
            </div>
          </FieldWrapper>
        )}
        {placeChildren != null && (
          <FieldWrapper>
            <div className="k-form-field-wrap">
              <Field
                name={"placeChild"}
                component={PlaceChildDropDown}
                label={"Fault Place Sub category"}
                required={true}
              />
            </div>
          </FieldWrapper>
        )}
        {props.jiraData.customfield_10827 != null && (
          <FieldWrapper>
            <div className="k-form-field-wrap">
              <Field
                name={"customfield_10827"}
                component={BasicDropDown}
                label={props.jiraData.customfield_10827.name}
              />
            </div>
          </FieldWrapper>
        )}
        {/*{props.jiraData.assignee != null && (*/}
        {/*  <FieldWrapper>*/}
        {/*    <div className="k-form-field-wrap">*/}
        {/*      <Field*/}
        {/*        name={"assignee"}*/}
        {/*        component={UserComboBox}*/}
        {/*        label={props.jiraData.assignee.name}*/}
        {/*        required={true}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*  </FieldWrapper>*/}
        {/*)}{" "}*/}
        {props.jiraData.reporter != null && (
          <FieldWrapper>
            <div className="k-form-field-wrap">
              <Field
                name={"reporter"}
                component={UserComboBox}
                label={props.jiraData.reporter.name}
                required={true}
              />
            </div>
          </FieldWrapper>
        )}
        {/*{props.jiraData.priority != null && (*/}
        {/*  <FieldWrapper>*/}
        {/*    <div className="k-form-field-wrap">*/}
        {/*      <Field*/}
        {/*        name={"priority"}*/}
        {/*        component={BasicDropDown}*/}
        {/*        label={props.jiraData.priority.name}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*  </FieldWrapper>*/}
        {/*)}*/}
        {/*{props.jiraData.customfield_12020 != null && (*/}
        {/*  <FieldWrapper>*/}
        {/*    <div className="k-form-field-wrap">*/}
        {/*      <Field*/}
        {/*        name={"customfield_12020"}*/}
        {/*        component={BasicDropDown}*/}
        {/*        label={props.jiraData.customfield_12020.name}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*  </FieldWrapper>*/}
        {/*)}*/}
      </TabStripTab>
    );
  };
  const renderCallerInfoTab = () => {
    if (props.jiraData == null) {
      return <div>Loading Jira data...</div>;
    }
    return (
      <TabStripTab title="Caller Information">
        {props.jiraData.customfield_11627 != null && (
          <FieldWrapper>
            <div className="k-form-field-wrap">
              <Field
                name={"customfield_11627"}
                component={BasicStringInput}
                label={props.jiraData.customfield_11627.name}
              />
            </div>
          </FieldWrapper>
        )}
        {props.jiraData.customfield_11628 != null && (
          <FieldWrapper>
            <div className="k-form-field-wrap">
              <Field
                name={"customfield_11628"}
                component={BasicStringInput}
                label={props.jiraData.customfield_11628.name}
              />
            </div>
          </FieldWrapper>
        )}

        {props.jiraData.customfield_11629 != null && ( //caller email
          <FieldWrapper>
            <div className="k-form-field-wrap">
              <Field
                name={"customfield_11629"}
                type={"email"}
                component={BasicStringInput}
                label={props.jiraData.customfield_11629.name}
                validator={emailValidator}
              />
            </div>
          </FieldWrapper>
        )}
      </TabStripTab>
    );
  };
  const renderMachineInfoTab = () => {
    return (
      <TabStripTab title="Machine Information">
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_16524"}
              component={BasicStringInput}
                        label={"Serial Number*"}
                        required={true}
            />
          </div>
        </FieldWrapper>
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_10070"}
              component={BasicStringInput}
              label={"Project Number"}
            />
          </div>
        </FieldWrapper>
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_11647"}
              label={"Machine Type"}
              component={BasicStringInput}
            />
          </div>
        </FieldWrapper>
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_11645"}
              label={"CNC Manufacturer"}
              component={BasicStringInput}
            />
          </div>
        </FieldWrapper>{" "}
        <FieldWrapper>
          <div className="k-form-field-wrap">
            <Field
              name={"customfield_11646"}
              label={"CNC Type"}
              component={BasicStringInput}
            />
          </div>
        </FieldWrapper>
      </TabStripTab>
    );
  };
  const renderJiraError = () => {
    if (jiraError != null) {
      return <span style={{ backgroundColor: "#fceceb" }}>{jiraError}</span>;
    }
  };
  const renderTabStrip = () => {
    return (
      <>
        {renderJiraError()}
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialValues={props.initialValues}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement style={{ maxWidth: 950 }}>
              <fieldset className={"k-form-fieldset"}>
                <TabStrip
                  selected={selected}
                  onSelect={handleSelect}
                  style={{ height: "70vh" }}
                >
                  {renderBasicInfoTab()}
           {/*      {renderCallerInfoTab()}*/}
                  {renderMachineInfoTab()}
                  {renderCustomerInfoTab()}
                </TabStrip>
              </fieldset>
              <div className="k-form-buttons">
                <button
                  type={"submit"}
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                  disabled={!formRenderProps.allowSubmit}
                  style={{ width: "100%" }}
                >
                  Submit
                </button>
              </div>
            </FormElement>
          )}
        />
      </>
    );
  };
    const renderCopyButton = () => {
        if (copySuccess) {
            return(<p>SCM ID copied to clipboard.</p>)
        } else {
            return (<Button onClick={() => copyIdHandler(jiraLink.split("browse/")[1])}>Copy ID: {jiraLink.split("browse/")[1]} to clipboard</Button>
               )
        }
    }
  if (props.initialValues == null || props.jiraData == null) {
    return <div>Unable to load customer information.</div>;
  }
  if (errorMessage != null) {
    return (
      <>
        <p>{errorMessage}</p>
      </>
    );
  }
  if (saveIssueLoading) {
    return <Spinner text="Creating issue" />;
  }
  if (saveSuccess) {
    return (
      <div>
        Issue successfully created.
        {jiraLink != null && (<>
          <div><br/>
            <a href={jiraLink} target="_blank" rel="noopener noreferrer">{jiraLink}</a>
                </div>
                <div style={{ marginTop: "10px" }}>
                    {renderCopyButton() }
                </div>
            </>
        )}
      </div>
    );
  }
  return renderTabStrip();
};

export default AddSupportCaseForm;
